<app-spinner-overlay />

@if (landingPage()) {
  <div class="landing-page" [innerHtml]="landingPage()"></div>
}

<!-- ─── Header ─────────────────────────────────────────────────────────────── -->
<div class="compilazione-header">
  <div class="compilazione-header__title">
    {{ titolo() }}
    @if (esercizio()) {
      <span>{{ esercizio() }}</span>
    }
  </div>
  <div class="compilazione-header__divider"></div>
  @if (esercizio()) {
    <div class="compilazione-header__counter">{{ currentSlideIndex + 1 }}/{{ totTematiche() }}</div>
  }
</div>

@if (tipo() && etichetteTipi() && etichetteTipi()![tipo()!]) {
  <div class="eti-tipo">
    Tipologia informazione da compilare:
    <span class="eti-elem"> {{ etichetteTipi()![tipo()!] }}</span>
  </div>
}

<!-- ─── Form ───────────────────────────────────────────────────────────────── -->
<div mat-dialog-content class="dialog-center-compilazione">
  <form [formGroup]="formCompilazione">
    <div formArrayName="ambiti">
      @for (amb of $any(ambitiFormArray)?.controls; track amb; let idxAmb = $index) {
        <div class="ambito" [formGroupName]="idxAmb">
          <div class="titolo-ambito">
            Ambito - {{ amb.value.titolo }}
            <div class="desc-ambito">{{ amb.value.descrizione }}</div>
          </div>

          <div formArrayName="tematiche">
            @for (tema of amb.get('tematiche')?.controls; track tema; let idxTem = $index) {
              <div [formGroupName]="idxTem" class="tematiche">
                <!-- ── Intestazione tematica ──────────────────────────────── -->
                @if (tema.get('domanda')?.value) {
                  <div class="cnt-tematica left-border">
                    <div class="titolo-tematica">Tematica - {{ tema.get('domanda')?.value }}</div>
                    @if (tema.get('idAzienda')?.value) {
                      <span
                        class="badge-tematica-aziendale"
                        style="margin-left: 10px"
                        matTooltip="Tematica aziendale"
                      >
                        Aziendale
                      </span>
                    }
                    @if (tema.get('descrizione')?.value) {
                      <div class="descrizione-tematica">{{ tema.get('descrizione')?.value }}</div>
                    }
                  </div>
                }

                <!-- ── Scelta Singola ─────────────────────────────────────── -->
                @if (tema.get('tipo')?.value === 'scelta_singola') {
                  <mat-radio-group
                    class="radio-group"
                    [value]="tema.get('risposte')?.value?.[0] ?? null"
                    (change)="onRadioChange($event, idxAmb, idxTem)"
                    #radioGroup="matRadioGroup"
                  >
                    @for (opz of tema.get('risposteVsme')?.value; track opz; let idxOpz = $index) {
                      <mat-radio-button [value]="opz.chiave">{{ opz.valore }}</mat-radio-button>

                      @if (opz.sottoOpzioni?.length && radioGroup.value === opz.chiave) {
                        <div class="sotto-opzioni">
                          @for (opzSec of opz.sottoOpzioni; track opzSec) {
                            <div class="radio-group">
                              <mat-checkbox
                                [value]="opzSec.chiave"
                                [checked]="checkSotto(opz.sottoRisposte, opzSec.chiave)"
                                (change)="
                                  cambioCheck($event, idxAmb, idxTem, idxOpz, opzSec.chiave)
                                "
                              >
                                {{ opzSec.valore }}
                              </mat-checkbox>
                            </div>
                          }
                        </div>
                      }
                    }
                  </mat-radio-group>
                }

                <!-- ── Scelta Multipla Valore ──────────────────────────────── -->
                @if (tema.get('tipo')?.value === 'scelta_multipla_valore') {
                  <div class="cnt-elem">
                    @if (compilazione().tipo === 'REPORT_VSME') {
                      <!-- ── REPORT_VSME ──────────────────────────────────── -->
                      @for (
                        rispostaVsme of tema.get('risposteVsme')?.controls;
                        track rispostaVsme;
                        let rIdx = $index
                      ) {
                        <div class="cnt-norma">
                          <mat-label class="titolo-elemento">
                            {{ rispostaVsme.get('valore')?.value }}
                          </mat-label>

                          @if (
                            rispostaVsme.get('codiceNormaVsme')?.value ||
                            rispostaVsme.get('descrizioneNormaVsme')?.value
                          ) {
                            <mat-label class="norma-label">
                              <span class="cod-norma">{{
                                rispostaVsme.get('codiceNormaVsme')?.value
                              }}</span>
                              {{ rispostaVsme.get('descrizioneNormaVsme')?.value }}
                            </mat-label>
                          }

                          @for (
                            sottoOpz of rispostaVsme.get('sottoOpzioni')?.controls;
                            track sottoOpz;
                            let sIdx = $index
                          ) {
                            <div
                              appFormContainer
                              [larghezza]="3"
                              class="margin-for-vsme item-block"
                            >
                              <!-- KPI -->
                              @if (sottoOpz.get('tipo')?.value === 'kpi') {
                                @for (
                                  valoreKpi of sottoOpz.get('valoriKpi')?.controls;
                                  track valoreKpi;
                                  let isFirst = $first;
                                  let idx = $index
                                ) {
                                  <mat-label class="titolo-elemento">
                                    {{ sottoOpz.get('nomeBreve')?.value }}
                                  </mat-label>

                                  @if (isFirst) {
                                    <mat-label class="descrizione">
                                      {{ sottoOpz.get('descrizione')?.value }}
                                    </mat-label>
                                  }

                                  <!-- campo-block wraps each KPI row uniformly -->
                                  <div
                                    class="campo-block"
                                    appFormContainer
                                    [larghezza]="3"
                                    [style.--campo-block-bg]="
                                      sottoOpz.get('notRisposta')?.value ? '#ffe4000d' : '#f7faf8'
                                    "
                                    [style.--campo-block-border]="
                                      sottoOpz.get('notRisposta')?.value ? '#fcd844' : '#A8D5B599'
                                    "
                                  >
                                    @if (!sottoOpz.get('moduloCompleto')?.value && isPMI()) {
                                      <div appFormElement [larghezza]="3" [riempi]="true">
                                        <ng-container
                                          [ngTemplateOutlet]="nonRispondo"
                                          [ngTemplateOutletContext]="{ sottoOpzioni: sottoOpz }"
                                        />
                                      </div>
                                    }

                                    @if (!sottoOpz.get('notRisposta')?.value) {
                                      <div class="cnt-field-comp" appFormContainer [larghezza]="3">
                                        <mat-form-field appFormElement [larghezza]="1">
                                          <mat-label>Unità di Misura</mat-label>
                                          <mat-select
                                            [formControl]="valoreKpi.get('idUnitaDiRiferimento')"
                                          >
                                            @for (
                                              um of arrayUm[
                                                valoreKpi.get('idCategoriaUnitaDiMisura')?.value
                                              ];
                                              track um
                                            ) {
                                              <mat-option [value]="um.id">{{
                                                um.descrizione
                                              }}</mat-option>
                                            }
                                          </mat-select>
                                        </mat-form-field>

                                        <div
                                          appFormElement
                                          [larghezza]="valueToggleAnni() ? 0.5 : 1"
                                          [riempi]="true"
                                          class="valore-container"
                                        >
                                          <mat-form-field style="width: 100%">
                                            <mat-label>Valore</mat-label>
                                            <input
                                              matInput
                                              type="number"
                                              step="0.01"
                                              inputmode="numeric"
                                              appInputNumber
                                              [formControl]="valoreKpi.get('valoreAttribuito')"
                                            />
                                            <mat-error appFormError />
                                          </mat-form-field>

                                          @if (valoreKpi.get('preCompilazioneInfos')?.value) {
                                            <div
                                              class="info-risposta info-risposta--bottom"
                                              [matTooltip]="
                                                getTooltip(
                                                  valoreKpi.get('preCompilazioneInfos')?.value
                                                )
                                              "
                                            >
                                              <span class="material-icons-outlined info-icon"
                                                >info</span
                                              >
                                            </div>
                                          }
                                        </div>

                                        @if (valueToggleAnni()) {
                                          <mat-label
                                            appFormElement
                                            [larghezza]="0.5"
                                            [riempi]="true"
                                            class="anno-label"
                                          >
                                            <span>Anno</span>
                                            <span class="anno-label__value">{{
                                              valoreKpi.get('anno')?.value
                                            }}</span>
                                          </mat-label>
                                        }

                                        @if (isFirst) {
                                          <div
                                            class="separa"
                                            appFormElement
                                            [larghezza]="3"
                                            [riempi]="true"
                                          ></div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              }

                              <!-- AZIONE -->
                              @if (sottoOpz.get('tipo')?.value === 'azione') {
                                <mat-label class="titolo-elemento">
                                  {{ sottoOpz.get('titolo')?.value }}
                                </mat-label>
                                <mat-label class="descrizione">
                                  {{ sottoOpz.get('descrizione')?.value }}
                                </mat-label>

                                <div
                                  class="campo-block"
                                  appFormContainer
                                  [larghezza]="3"
                                  [style.--campo-block-bg]="
                                    sottoOpz.get('notRisposta')?.value ? '#ffe4000d' : '#f7faf8'
                                  "
                                  [style.--campo-block-border]="
                                    sottoOpz.get('notRisposta')?.value ? '#fcd844' : '#A8D5B599'
                                  "
                                >
                                  @if (!sottoOpz.get('moduloCompleto')?.value && isPMI()) {
                                    <div appFormElement [larghezza]="3" [riempi]="true">
                                      <ng-container
                                        [ngTemplateOutlet]="nonRispondo"
                                        [ngTemplateOutletContext]="{ sottoOpzioni: sottoOpz }"
                                      />
                                    </div>
                                  }

                                  @if (!sottoOpz.get('notRisposta')?.value) {
                                    <div class="cnt-field-comp" appFormContainer [larghezza]="3">
                                      <mat-form-field
                                        appFormElement
                                        [larghezza]="3"
                                        [riempi]="true"
                                      >
                                        <mat-label>Risposta</mat-label>
                                        <textarea
                                          matInput
                                          rows="4"
                                          [formControl]="sottoOpz.get('risposta')"
                                        ></textarea>
                                        <mat-error appFormError />
                                      </mat-form-field>

                                      <ng-container
                                        [ngTemplateOutlet]="preCompInfo"
                                        [ngTemplateOutletContext]="{ item: sottoOpz }"
                                      />
                                    </div>

                                    <div
                                      class="separa"
                                      appFormElement
                                      [larghezza]="3"
                                      [riempi]="true"
                                    ></div>
                                  }
                                </div>
                              }

                              <!-- CHECKBOX -->
                              @if (sottoOpz.get('tipo')?.value === 'checkbox') {
                                <mat-label class="titolo-elemento">
                                  {{ sottoOpz.get('descrizione')?.value }}
                                </mat-label>

                                <div
                                  class="campo-block"
                                  appFormContainer
                                  [larghezza]="3"
                                  [style.--campo-block-bg]="
                                    sottoOpz.get('notRisposta')?.value ? '#ffe4000d' : '#f7faf8'
                                  "
                                  [style.--campo-block-border]="
                                    sottoOpz.get('notRisposta')?.value ? '#fcd844' : '#A8D5B599'
                                  "
                                >
                                  @if (!sottoOpz.get('moduloCompleto')?.value && isPMI()) {
                                    <div appFormElement [larghezza]="3" [riempi]="true">
                                      <ng-container
                                        [ngTemplateOutlet]="nonRispondo"
                                        [ngTemplateOutletContext]="{ sottoOpzioni: sottoOpz }"
                                      />
                                    </div>
                                  }

                                  @if (!sottoOpz.get('notRisposta')?.value) {
                                    <div class="cnt-field-comp" appFormContainer [larghezza]="3">
                                      <mat-form-field
                                        appFormElement
                                        [larghezza]="3"
                                        [riempi]="true"
                                      >
                                        <mat-label>Risposta</mat-label>
                                        <textarea
                                          matInput
                                          rows="4"
                                          [formControl]="sottoOpz.get('risposta')"
                                        ></textarea>
                                        <mat-error appFormError />
                                      </mat-form-field>
                                    </div>

                                    <div
                                      class="separa"
                                      appFormElement
                                      [larghezza]="3"
                                      [riempi]="true"
                                    ></div>
                                  }
                                </div>
                              }

                              <!-- DYNAMIC TABLE -->
                              @if (sottoOpz.get('tipo')?.value === 'dynamic_table') {
                                <mat-label class="titolo-elemento">
                                  {{ sottoOpz.get('titoloTabella')?.value }}
                                </mat-label>

                                <div
                                  class="campo-block"
                                  [style.--campo-block-bg]="
                                    sottoOpz.get('notRisposta')?.value ? '#ffe4000d' : '#f7faf8'
                                  "
                                  [style.--campo-block-border]="
                                    sottoOpz.get('notRisposta')?.value ? '#fcd844' : '#A8D5B599'
                                  "
                                >
                                  @if (!sottoOpz.get('moduloCompleto')?.value && isPMI()) {
                                    <div appFormElement [larghezza]="3" [riempi]="true">
                                      <ng-container
                                        [ngTemplateOutlet]="nonRispondo"
                                        [ngTemplateOutletContext]="{ sottoOpzioni: sottoOpz }"
                                      />
                                    </div>
                                  }

                                  @if (!sottoOpz.get('notRisposta')?.value) {
                                    <div class="cnt-field-comp" appFormContainer [larghezza]="3">
                                      <div style="width: 100%">
                                        <app-tabella-cfg-dinamica
                                          #cfgTabellaDinamica
                                          [tabella]="generaOggettoTabella(sottoOpz.value)"
                                          (salvataggioTabella)="
                                            inserisciTabellaNellaForm($event, sottoOpz)
                                          "
                                          [temporaryToken]="temporaryToken()"
                                          [disabilitaHeaderRC]="true"
                                          [isRequired]="
                                            !sottoOpz.get('moduloCompleto')?.value && isPMI()
                                          "
                                        />
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    } @else {
                      <!-- ── Non-VSME ─────────────────────────────────────── -->

                      <!-- IMPATTI -->
                      @if (tema.get('impatti')?.controls?.length) {
                        @for (impatto of tema.get('impatti')?.controls; track impatto) {
                          <div class="item-block">
                            <mat-label class="descrizione">
                              {{ impatto.get('descrizione')?.value }}
                            </mat-label>
                            <div class="campo-block" appFormContainer [larghezza]="3">
                              <div class="cnt-field-comp" appFormContainer [larghezza]="3">
                                <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
                                  <mat-label>Risposta</mat-label>
                                  <input
                                    matInput
                                    type="number"
                                    step="0.01"
                                    appInputNumber
                                    [formControl]="impatto.get('valoreAttribuito')"
                                  />
                                  <mat-error appFormError />
                                </mat-form-field>
                              </div>
                            </div>
                            <div
                              class="separa"
                              appFormElement
                              [larghezza]="3"
                              [riempi]="true"
                            ></div>
                          </div>
                        }
                      }

                      <!-- IMPEGNI -->
                      @if (tema.get('impegni')?.controls?.length) {
                        @for (impegno of tema.get('impegni')?.controls; track impegno) {
                          <div class="item-block">
                            <div class="cnt-info-compilazione">
                              <mat-label class="titolo-elemento">
                                {{ impegno.get('titolo')?.value }}

                                @if (impegno.get('idAzienda')?.value) {
                                  <div
                                    style="height: 22px; margin-left: 8px"
                                    class="badge-tematica-aziendale"
                                    matTooltip="Impegno aziendale"
                                  >
                                    Aziendale
                                  </div>
                                }
                              </mat-label>

                              @if (impegno.get('descrizione')?.value) {
                                <mat-label class="note">
                                  <a class="nota-prefix">Nota per la compilazione </a
                                  >{{ impegno.get('descrizione')?.value }}
                                </mat-label>
                              }

                              @if (impegno.get('note')?.value) {
                                <div
                                  appFormElement
                                  [larghezza]="4"
                                  [riempi]="true"
                                  class="testo-linea-guida"
                                >
                                  <div class="titolo-linea-guida">
                                    <div class="linea-guida-title">
                                      Linea guida per la stesura dell'impegno aziendale
                                    </div>
                                    <div class="linea-guida">{{ impegno.get('note')?.value }}</div>
                                  </div>
                                </div>
                              }
                            </div>
                            <div appFormContainer [larghezza]="3">
                              <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
                                <mat-label>Risposta</mat-label>
                                <textarea
                                  matInput
                                  rows="4"
                                  [formControl]="impegno.get('risposta')"
                                ></textarea>
                                <mat-error appFormError />
                              </mat-form-field>

                              <ng-container
                                [ngTemplateOutlet]="preCompInfo"
                                [ngTemplateOutletContext]="{ item: impegno }"
                              />
                            </div>
                            <div
                              class="separa"
                              appFormElement
                              [larghezza]="3"
                              [riempi]="true"
                            ></div>
                          </div>
                        }
                      }

                      <!-- AZIONI (non POLICY / PIANO) -->
                      @if (
                        tema.get('azioni')?.controls?.length &&
                        compilazione().tipo !== 'POLICY' &&
                        compilazione().tipo !== 'PIANO'
                      ) {
                        @for (azione of tema.get('azioni')?.controls; track azione) {
                          <div class="item-block">
                            <div class="cnt-info-compilazione">
                              <mat-label class="titolo-elemento">
                                {{ azione.get('titolo')?.value }}

                                @if (azione.get('idAzienda')?.value) {
                                  <div
                                    style="height: 22px; margin-left: 8px"
                                    class="badge-tematica-aziendale"
                                    matTooltip="Azione e Buona pratica aziendale"
                                  >
                                    Aziendale
                                  </div>
                                }
                              </mat-label>
                              <mat-label class="descrizione">
                                {{ azione.get('descrizione')?.value }}
                              </mat-label>

                              @if (azione.get('note')?.value) {
                                <mat-label class="note">
                                  <a class="nota-prefix">Nota per la compilazione </a
                                  >{{ azione.get('note')?.value }}
                                </mat-label>
                              }
                            </div>
                            <div appFormContainer [larghezza]="3">
                              <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
                                <mat-label>Risposta</mat-label>
                                <textarea
                                  matInput
                                  rows="4"
                                  [formControl]="azione.get('risposta')"
                                ></textarea>
                                <mat-error appFormError />
                              </mat-form-field>

                              <ng-container
                                [ngTemplateOutlet]="preCompInfo"
                                [ngTemplateOutletContext]="{ item: azione }"
                              />
                            </div>
                          </div>
                          <div class="separa" appFormElement [larghezza]="3" [riempi]="true"></div>
                        }
                      }

                      <!-- AZIONI (POLICY / PIANO) -->
                      @if (
                        tema.get('azioni')?.controls?.length &&
                        (compilazione().tipo === 'POLICY' || compilazione().tipo === 'PIANO')
                      ) {
                        @for (azione of tema.get('azioni')?.controls; track azione) {
                          <div class="item-block">
                            @if (compilazione().tipo === 'POLICY') {
                              <div class="cnt-info-compilazione">
                                <mat-label class="titolo-elemento">
                                  {{ azione.get('titolo')?.value }}

                                  @if (azione.get('idAzienda')?.value) {
                                    <div
                                      style="height: 22px; margin-left: 8px"
                                      class="badge-tematica-aziendale"
                                      matTooltip="Azione e Buona pratica aziendale"
                                    >
                                      Aziendale
                                    </div>
                                  }
                                </mat-label>
                                <mat-label class="descrizione">
                                  {{ azione.get('descrizione')?.value }}
                                </mat-label>
                              </div>
                            } @else {
                              <div class="target-header">
                                <span class="tlt-target">Obiettivo:</span>
                                <span class="valore-testo">{{
                                  azione.get('titoloObiettivo')?.value
                                }}</span>

                                <span class="tlt-target">Target qualitativo:</span>
                                <span class="valore-testo">{{ azione.get('titolo')?.value }}</span>

                                <span class="tlt-target">Azione e Buona pratica:</span>
                                <span class="valore-testo">{{
                                  azione.get('descrizione')?.value
                                }}</span>
                              </div>
                            }
                            @if (azione.get('note')?.value) {
                              <mat-label class="note" style="margin-top: 10px; margin-left: 5px">
                                <a class="nota-prefix">Nota per la compilazione </a
                                >{{ azione.get('note')?.value }}
                              </mat-label>
                            }

                            <div class="target-row" appFormContainer [larghezza]="3">
                              @if (compilazione().tipo === 'PIANO') {
                                <mat-form-field class="anno-attuazione">
                                  <mat-label>Anno attuazione</mat-label>
                                  <input
                                    matInput
                                    type="number"
                                    step="1"
                                    inputmode="numeric"
                                    appInputNumber
                                    [formControl]="azione.get('anno')"
                                  />
                                  <mat-error appFormError />
                                </mat-form-field>
                              }

                              <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
                                <mat-label
                                  >Descrizione breve dell'azione che l'azienda attuerà nell'anno
                                  selezionato</mat-label
                                >
                                <textarea
                                  matInput
                                  rows="4"
                                  [formControl]="azione.get('rispostaBreve')"
                                ></textarea>
                                <mat-error appFormError />
                              </mat-form-field>

                              @if (azione.get('risposta')?.value) {
                                <div
                                  class="info-risposta"
                                  [matTooltip]="
                                    getTooltip(azione.get('preCompilazioneInfos')?.value)
                                  "
                                >
                                  <span class="material-icons-outlined info-icon">info</span>
                                  <span class="risposta-read-only">{{
                                    azione.get('risposta')?.value
                                  }}</span>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      }

                      <!-- KPI -->
                      @if (tema.get('kpis')?.controls?.length) {
                        @for (kpis of tema.get('kpis')?.controls; track kpis) {
                          <div class="item-block">
                            @if (compilazione().tipo !== 'PIANO') {
                              <mat-label class="titolo-elemento">
                                {{ kpis.get('titolo')?.value }}

                                @if (kpis.get('idAzienda')?.value) {
                                  <div
                                    style="height: 22px; margin-left: 8px"
                                    class="badge-tematica-aziendale"
                                    matTooltip="KPI aziendale"
                                  >
                                    Aziendale
                                  </div>
                                }
                              </mat-label>
                              <mat-label class="descrizione">
                                {{ kpis.get('descrizione')?.value }}
                              </mat-label>

                              @if (kpis.get('note')?.value) {
                                <mat-label class="note">
                                  <a class="nota-prefix">Nota per la compilazione </a
                                  >{{ kpis.get('note')?.value }}
                                </mat-label>
                              }

                              <!-- Each KPI value row uses the same campo-block + cnt-field-comp
                                   structure as in the VSME branch -->
                              @for (
                                valoreKpi of kpis.get('valoriKpi')?.controls;
                                track valoreKpi;
                                let isFirst = $first;
                                let idx = $index
                              ) {
                                <div class="campo-block" appFormContainer [larghezza]="3">
                                  <div class="cnt-field-comp" appFormContainer [larghezza]="3">
                                    <mat-form-field appFormElement [larghezza]="1">
                                      <mat-label>Unità di Misura</mat-label>
                                      <mat-select
                                        [formControl]="valoreKpi.get('idUnitaDiRiferimento')"
                                      >
                                        @for (
                                          um of arrayUm[
                                            valoreKpi.get('idCategoriaUnitaDiMisura')?.value
                                          ];
                                          track um
                                        ) {
                                          <mat-option
                                            [value]="um.id"
                                            (onSelectionChange)="
                                              cambiaUnitaMisuaraAnniPrecedenti(
                                                kpis.get('valoriKpi'),
                                                $event,
                                                isFirst
                                              )
                                            "
                                          >
                                            {{ um.descrizione }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>

                                    <div
                                      appFormElement
                                      [larghezza]="valueToggleAnni() ? 0.5 : 1"
                                      [riempi]="true"
                                      class="valore-container"
                                    >
                                      <mat-form-field style="width: 100%">
                                        <mat-label>Valore</mat-label>
                                        <input
                                          matInput
                                          type="number"
                                          step="0.01"
                                          inputmode="numeric"
                                          appInputNumber
                                          [formControl]="valoreKpi.get('valoreAttribuito')"
                                        />
                                        <mat-error appFormError />
                                      </mat-form-field>

                                      @if (valoreKpi.get('preCompilazioneInfos')?.value) {
                                        <div
                                          class="info-risposta info-risposta--bottom"
                                          [matTooltip]="
                                            getTooltip(valoreKpi.get('preCompilazioneInfos')?.value)
                                          "
                                        >
                                          <span class="material-icons-outlined info-icon"
                                            >info</span
                                          >
                                        </div>
                                      }
                                    </div>

                                    <mat-label
                                      appFormElement
                                      [larghezza]="0.5"
                                      [riempi]="true"
                                      class="anno-label"
                                    >
                                      <span>Anno</span>
                                      <span class="anno-label__value">{{
                                        valoreKpi.get('anno')?.value
                                      }}</span>
                                      @if (!isFirst) {
                                        <button
                                          mat-icon-button
                                          color="warn"
                                          title="Elimina"
                                          class="btn-elimina-anno"
                                          (click)="
                                            eliminaAnniPrecedenti(kpis.get('valoriKpi'), idx)
                                          "
                                        >
                                          <mat-icon>delete</mat-icon>
                                        </button>
                                      }
                                    </mat-label>

                                    @if (isFirst) {
                                      <div
                                        class="separa"
                                        appFormElement
                                        [larghezza]="3"
                                        [riempi]="true"
                                      ></div>
                                    }
                                  </div>
                                </div>
                              }
                            }

                            <!-- TARGET -->
                            <div
                              class="target-container"
                              [ngClass]="{ 'target-border': compilazione().tipo !== 'PIANO' }"
                            >
                              @if (targetConsigliato()) {
                                <div class="targhettina-consigliato">
                                  <mat-icon
                                    class="material-icons-outlined"
                                    style="transform: scale(0.9)"
                                  >
                                    emoji_objects
                                  </mat-icon>
                                  *Consigliato
                                </div>
                              }

                              <div class="target-header">
                                @if (compilazione().tipo === 'PIANO') {
                                  <span class="tlt-target">Obiettivo:</span>
                                  <span class="valore-testo">{{
                                    kpis.get('titoloObiettivo')?.value
                                  }}</span>

                                  <span class="tlt-target">Target quantitativo:</span>
                                  <span class="valore-testo">{{ kpis.get('titolo')?.value }}</span>

                                  <span class="tlt-target">Indicatore quantitativo [KPI]:</span>
                                  <span class="valore-testo">
                                    {{ kpis.get('descrizione')?.value }}</span
                                  >
                                } @else {
                                  <div class="titolo-sezione-dialog">Compilazione Target</div>
                                }
                              </div>

                              @if (kpis.get('note')?.value && compilazione().tipo === 'PIANO') {
                                <mat-label class="note" style="margin-top: 0px; margin-left: 5px">
                                  <a class="nota-prefix">Nota per la compilazione </a
                                  >{{ kpis.get('note')?.value }}
                                </mat-label>
                              }

                              @if (compilazione().tipo !== 'PIANO') {
                                <div
                                  class="descrizione-sezione-dialog"
                                  style="padding-bottom: 10px; margin-left: 5px"
                                >
                                  Per questo KPI è prevista la compilazione di uno o più target.
                                </div>
                              }

                              @for (
                                valoreTarget of kpis.get('valoriTarget')?.controls;
                                track valoreTarget
                              ) {
                                <div class="target-row">
                                  <mat-form-field appFormElement [larghezza]="0.5">
                                    <mat-label>Anno</mat-label>
                                    <input
                                      matInput
                                      type="number"
                                      step="1"
                                      inputmode="numeric"
                                      appInputNumber
                                      [formControl]="valoreTarget.get('anno')"
                                    />
                                    <mat-error style="white-space: nowrap" appFormError />
                                  </mat-form-field>

                                  <mat-form-field>
                                    <mat-label>Direzione target</mat-label>
                                    <mat-select [formControl]="valoreTarget.get('tipoAzione')">
                                      @for (option of tipoAzione; track option.chiave) {
                                        <mat-option [value]="option.chiave">{{
                                          option.descrizione
                                        }}</mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>

                                  <mat-form-field appFormElement [larghezza]="1">
                                    <mat-label>Unità di Misura</mat-label>
                                    <mat-select
                                      [formControl]="valoreTarget.get('idUnitaDiRiferimento')"
                                    >
                                      @for (
                                        um of arrayUm[
                                          valoreTarget.get('idCategoriaUnitaDiMisura')?.value
                                        ];
                                        track um
                                      ) {
                                        <mat-option [value]="um.id">{{
                                          um.descrizione
                                        }}</mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>

                                  <div class="valore-container valore-container--flex">
                                    <mat-form-field style="width: 100%">
                                      <mat-label>Valore</mat-label>
                                      <input
                                        matInput
                                        type="number"
                                        step="0.01"
                                        inputmode="numeric"
                                        appInputNumber
                                        [formControl]="valoreTarget.get('valoreAttribuito')"
                                      />
                                      <mat-error appFormError />
                                    </mat-form-field>

                                    @if (valoreTarget.get('preCompilazioneInfos')?.value) {
                                      <div
                                        class="info-risposta info-risposta--bottom"
                                        [matTooltip]="
                                          getTooltip(
                                            valoreTarget.get('preCompilazioneInfos')?.value
                                          )
                                        "
                                      >
                                        <span class="material-icons-outlined info-icon">info</span>
                                      </div>
                                    }
                                  </div>
                                </div>
                              }

                              @if (compilazione().tipo !== 'PIANO') {
                                <div
                                  appFormElement
                                  [larghezza]="1"
                                  [riempi]="true"
                                  class="btn-salvataggio-cat"
                                  style="padding-bottom: 10px"
                                >
                                  <button
                                    mat-stroked-button
                                    [disabled]="!!isPermessoSoloRead()"
                                    (click)="visualizzaCampiTarget(kpis)"
                                    class="btn-aggiungi-target"
                                  >
                                    + Aggiungi Nuovo
                                  </button>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      }

                      <!-- CERTIFICAZIONI -->
                      @if (tema.get('certificazioni')?.controls?.length) {
                        @for (certif of tema.get('certificazioni')?.controls; track certif) {
                          <div class="item-block">
                            <div class="cnt-info-compilazione">
                              <mat-label class="titolo-elemento">
                                {{ certif.get('titolo')?.value }}
                                @if (certif.get('idAzienda')?.value) {
                                  <div
                                    style="height: 22px; margin-left: 8px"
                                    class="badge-tematica-aziendale"
                                    matTooltip="Certificazione aziendale"
                                  >
                                    Aziendale
                                  </div>
                                }
                              </mat-label>
                              <mat-label class="descrizione">
                                {{ certif.get('descrizione')?.value }}
                              </mat-label>

                              @if (certif.get('note')?.value) {
                                <mat-label class="note">
                                  <a class="nota-prefix">Nota per la compilazione </a
                                  >{{ certif.get('note')?.value }}
                                </mat-label>
                              }
                            </div>

                            <div class="certif-row" appFormElement [larghezza]="3" [riempi]="true">
                              <div style="flex: 1">
                                <mat-form-field
                                  style="width: 100%"
                                  appFormElement
                                  [larghezza]="3"
                                  [riempi]="true"
                                >
                                  <mat-label>Dettaglio certificazione</mat-label>
                                  <textarea
                                    rows="7"
                                    matInput
                                    [formControl]="certif.get('risposta')"
                                  ></textarea>
                                  <mat-error appFormError />
                                </mat-form-field>
                              </div>

                              <div class="certif-img-wrapper">
                                <div class="certif-img-border">
                                  <div class="image-container">
                                    <div
                                      class="immagine-cont"
                                      [style.background-image]="
                                        'url(' +
                                        getUrlImg(
                                          amb.value.id,
                                          tema.get('id')?.value,
                                          certif.get('id')?.value,
                                          certif.get('urlFile')?.value
                                        ) +
                                        ')'
                                      "
                                    >
                                      <div class="overlay">
                                        <div class="text">Importa una nuova immagine</div>
                                      </div>
                                    </div>
                                    <input
                                      [disabled]="!!isPermessoSoloRead()"
                                      type="file"
                                      #fileInputImg
                                      (change)="
                                        fileSelezionato(
                                          $any($event.target)?.files,
                                          amb.value.id,
                                          tema.get('id')?.value,
                                          certif.get('id')?.value,
                                          fileInputImg
                                        )
                                      "
                                      class="select-profile-picture"
                                    />
                                  </div>
                                </div>

                                @if (
                                  isFilePresente(
                                    amb.value.id,
                                    tema.get('id')?.value,
                                    certif.get('id')?.value,
                                    certif.get('urlFile')?.value
                                  )
                                ) {
                                  <button
                                    [disabled]="!!isPermessoSoloRead()"
                                    class="bottone-elimina"
                                    mat-flat-button
                                    color="warn"
                                    (click)="
                                      eliminaImg(
                                        amb.value.id,
                                        tema.get('id')?.value,
                                        certif.get('id')?.value
                                      )
                                    "
                                  >
                                    Rimuovi
                                  </button>
                                } @else {
                                  <div class="fileinput">
                                    <button
                                      [disabled]="!!isPermessoSoloRead()"
                                      class="bottone-elimina"
                                      mat-flat-button
                                      color="accent"
                                    >
                                      Importa <mat-icon>file_upload</mat-icon>
                                    </button>
                                    <input
                                      [disabled]="!!isPermessoSoloRead()"
                                      #fileInput
                                      type="file"
                                      name="fileDaCaricare"
                                      (change)="
                                        fileSelezionato(
                                          $any($event.target)?.files,
                                          amb.value.id,
                                          tema.get('id')?.value,
                                          certif.get('id')?.value,
                                          fileInput
                                        )
                                      "
                                      (click)="$any($event.target).value = null"
                                    />
                                  </div>
                                }
                              </div>
                            </div>

                            <ng-container
                              [ngTemplateOutlet]="preCompInfo"
                              [ngTemplateOutletContext]="{ item: certif }"
                            />

                            <div
                              class="separa"
                              appFormElement
                              [larghezza]="3"
                              [riempi]="true"
                            ></div>
                          </div>
                        }
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </form>
</div>

<!-- ─── Footer ─────────────────────────────────────────────────────────────── -->
<div mat-dialog-actions class="dialog-footer-cont">
  <button mat-flat-button color="accent" class="accent-button" (click)="chiudi()">Chiudi</button>

  @if (!isAnteprima() && !isPermessoSoloRead()) {
    <button mat-flat-button color="primary" class="primary-button" (click)="salva()">
      Conferma
    </button>
  }
</div>

<!-- ─── Template: Pre-compilazione info ────────────────────────────────────── -->
<ng-template #preCompInfo let-item="item">
  @if (item.get('preCompilazioneInfos')?.value) {
    <div class="info-risposta">
      <span class="material-icons-outlined info-icon">info</span>
      <mat-label class="risposta-read-only">
        {{ getTooltip(item.get('preCompilazioneInfos')?.value) }}
      </mat-label>
    </div>
  }
</ng-template>

<!-- ─── Template: Non Rispondo ─────────────────────────────────────────────── -->
<ng-template #nonRispondo let-sottoOpzioni="sottoOpzioni">
  <div class="giustifica-risposta">
    <mat-slide-toggle
      [formControl]="sottoOpzioni.get('notRisposta')"
      labelPosition="before"
      (change)="slideMotivazioneChanged($event, sottoOpzioni)"
    >
      Non ho una risposta!
    </mat-slide-toggle>
  </div>

  @if (sottoOpzioni.get('notRisposta')?.value) {
    <app-motivazione-risposta-vsme
      [sottoRisposta]="sottoOpzioni.getRawValue()"
      [readOnly]="!!isPermessoSoloRead()"
      [isPMI]="isPMI()"
      [isRequired]="true"
      [showTouchedField]="showTouchedField()"
    />
  }
</ng-template>
